import { useState, useEffect } from 'react';

const useTimeInIST = () => {
  const [currentTime, setCurrentTime] = useState('');
  const [currentDate, setCurrentDate] = useState('');

  useEffect(() => {
    const updateTime = () => {
      const now = new Date();
      const timeString = now.toLocaleTimeString('en-US', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: true,
        timeZone: 'Asia/Kolkata'
      });
      const dateString = now.toLocaleDateString('en-US', {
        weekday: 'long',
        timeZone: 'Asia/Kolkata'
      });
      setCurrentTime(`${timeString} IST`);
      setCurrentDate(dateString);
    };

    updateTime();
    const interval = setInterval(updateTime, 1000);
    return () => clearInterval(interval);
  }, []);

  return { currentTime, currentDate };
};

export default useTimeInIST;
